document.addEventListener("DOMContentLoaded", (event) => {
  const modal = document.getElementById('recentlyAddedModal');
  const overlay = modal.querySelector('.recently-added-items__overlay');
  const closeBtn = modal.querySelector('.recently-added-items__close');
  const closeBtnBuy = modal.querySelector('.recently-added-items__continue');
  let hasBeenHidden = false;
  const KEY = 'recentlyAddedModalShown';
  const EXPIRATION = 24 * 60 * 60 * 1000;

  function shouldOpenModal() {
    const data = JSON.parse(localStorage.getItem(KEY));

    if (!data) return true;

    const now = Date.now();
    return (now - data.timestamp) > EXPIRATION;
  }

  function markModalAsShown() {
    localStorage.setItem(KEY, JSON.stringify({
      timestamp: Date.now()
    }));
  }

  async function loadCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const list = document.getElementById('recentlyAddedList');
    const subtotal = document.getElementById('recentlyAddedSubtotal');

    list.innerHTML = '';

    cart.items.forEach((item) => {
      const sizeOption = item.options_with_values.find((opt) => opt.name === 'Size');
      const size = sizeOption ? sizeOption.value : '';

      const html = `
            <div class="recently-added-items__product">
            <div class="recently-added-items__image-wrapper">
                <picture>
                  <source srcset="${resizeImage(item.image, '20x')} 20w, ${resizeImage(item.image, '250x')} 250w">
                  <img
                    src="${resizeImage(item.image, '20x')}"
                    alt="${item.product_title}"
                    class="recently-added-items__image">
                </picture>
            </div>
            <div class="recently-added-items__details">
                <div class="recently-added-items__info-main">
                    <p class="recently-added-items__name">${item.product_title}</p>
                    <p class="recently-added-items__price">${formatMoney(item.final_line_price)}</p>
                </div>

                <div class="recently-added-items__meta">
                    <span>Size ${size}</span>
                    <span>Qty ${item.quantity}</span>
                </div>
                </div>
            </div>
        `;

      list.insertAdjacentHTML('beforeend', html);
    });

    subtotal.textContent = formatMoney(cart.total_price);

    return cart;
  }

  async function openModal() {
    const isOpenCart = document.body.classList.contains('sitecart-byob-hide-bar');
    if (!shouldOpenModal() || isOpenCart) return;

    const cart = await loadCart();
    if (!cart.items.length) return;

    modal.classList.add('recently-added-items--active');
    document.body.classList.add('no-scroll');
  }

  function closeModal(e) {
    e.preventDefault();
    modal.classList.remove('recently-added-items--active');
    document.body.classList.remove('no-scroll');

    markModalAsShown();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function resizeImage(url, size = '250x') {
    if (!url) return '';

    return url.replace(/(\.(jpg|jpeg|png|webp))/i, `_${size}$1`);
  }

  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  closeBtnBuy.addEventListener('click', closeModal);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hasBeenHidden = true;
    }

    if (document.visibilityState === 'visible' && hasBeenHidden) {
      openModal();
      hasBeenHidden = false;
    }
  });

  function handleVisible() {
    if (document.visibilityState === 'visible') {
      openModal();
    }
  }

  //document.addEventListener('visibilitychange', handleVisible);
  //window.addEventListener('focus', handleVisible);
  //window.addEventListener('pageshow', handleVisible);
});